"use strict";
exports.__esModule = true;
exports.MillenniumDate = void 0;
var MillenniumWeek_1 = require("./MillenniumWeek");
var MillenniumWeekday_1 = require("./MillenniumWeekday");
var SimpleDateFormat_1 = require("./SimpleDateFormat");
/**
 * Helper functions
 */
function getDaysInMonths(isLeapYear) {
    var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (isLeapYear) {
        days[1] = 29;
    }
    return days;
}
function calculateDayForYear(year) {
    return year * 365 + (year !== 0 ? Math.floor((year - 1) / 4) + 1 : 0);
}
/*
 * Main constructor
 */
var MillenniumDate = /** @class */ (function () {
    function MillenniumDate(dayNumber) {
        if (dayNumber instanceof MillenniumDate) {
            dayNumber = dayNumber.getDayNumber();
        }
        this.dayNumber = dayNumber;
    }
    MillenniumDate.create = function (year, month, day) {
        var resultDayNumber;
        if ((year > 100 && year < 2000) ||
            year > 2100 ||
            month > 12 ||
            month < 1 ||
            day > 31 ||
            day < 0) {
            throw new Error("Invalid date.");
        }
        year = year % 100;
        month--;
        resultDayNumber = calculateDayForYear(year);
        resultDayNumber += 30 * month;
        if (month === 1) {
            // February
            resultDayNumber++;
        }
        if (month === 2) {
            // March
            resultDayNumber--;
        }
        if (month > 1 && year % 4 === 0) {
            // February, leap year
            resultDayNumber++;
        }
        if (month > 4) {
            // May
            resultDayNumber++;
        }
        if (month > 6) {
            // July
            resultDayNumber++;
        }
        if (month > 7) {
            // August
            resultDayNumber++;
        }
        if (month > 9) {
            // October
            resultDayNumber++;
        }
        resultDayNumber += day - 1;
        return new MillenniumDate(resultDayNumber);
    };
    MillenniumDate.today = function () {
        var now = new Date();
        return MillenniumDate.create(now.getFullYear(), now.getMonth() + 1, now.getDate());
    };
    MillenniumDate.lastDateOfMonth = function (year, month) {
        var firstDate = MillenniumDate.create(year, month, 1);
        var daysInMonth = getDaysInMonths(firstDate.isLeapYear())[month - 1];
        return MillenniumDate.create(year, month, daysInMonth);
    };
    MillenniumDate.fromYyyyMMdd = function (dateString) {
        var year = parseInt(dateString.substring(0, 4), 10);
        var month = parseInt(dateString.substring(4, 6), 10);
        var day = parseInt(dateString.substring(6, 8), 10);
        return MillenniumDate.create(year, month, day);
    };
    /**
     * Get the number of days since January 1 2001.
     *
     * @return {int} day timestamp
     */
    MillenniumDate.prototype.getDayNumber = function () {
        return this.dayNumber;
    };
    MillenniumDate.prototype.isBefore = function (otherDate) {
        return this.dayNumber < otherDate.getDayNumber();
    };
    MillenniumDate.prototype.isAfter = function (otherDate) {
        return this.dayNumber > otherDate.getDayNumber();
    };
    /**
     * Return the number of days between two dates.
     *
     * @param  {MillenniumDate} other date to compare with
     * @return {int}       days between dates
     */
    MillenniumDate.prototype.daysBetween = function (other) {
        if (this.dayNumber > other.getDayNumber()) {
            return this.dayNumber - other.getDayNumber();
        }
        return other.getDayNumber() - this.dayNumber;
    };
    MillenniumDate.prototype.isLeapYear = function () {
        return this.getYear() % 4 === 0;
    };
    MillenniumDate.prototype.getYear = function () {
        var year = Math.floor(this.dayNumber / 365);
        var days = calculateDayForYear(year);
        if (this.dayNumber < days) {
            year--;
        }
        return year + 2000;
    };
    MillenniumDate.prototype.getDayOfYear = function () {
        var tempDayNumber = this.getDayNumber();
        var year = Math.floor(tempDayNumber / 365);
        var daysToJan1 = calculateDayForYear(year);
        if (tempDayNumber < daysToJan1) {
            daysToJan1 = calculateDayForYear(year - 1);
        }
        return tempDayNumber - daysToJan1 + 1;
    };
    /**
     * Return the index of the month (0-11).
     * @return {int} month index
     */
    MillenniumDate.prototype.getMonth = function () {
        var dayOfYear = this.getDayOfYear();
        var daysInMonths = getDaysInMonths(this.isLeapYear());
        var month = -1;
        while (dayOfYear > 0) {
            month++;
            dayOfYear = dayOfYear - daysInMonths[month];
        }
        return month;
    };
    /**
     * Return the day of month.
     * @return {int} day in month
     */
    MillenniumDate.prototype.getDate = function () {
        var dayOfYear = this.getDayOfYear();
        var daysInMonths = getDaysInMonths(this.isLeapYear());
        var month = this.getMonth();
        var i;
        for (i = 0; i < month; i++) {
            dayOfYear = dayOfYear - daysInMonths[i];
        }
        return dayOfYear;
    };
    /**
     * Return the day of the week as an index, where 0 is Sunday and 6 is Saturday.
     * @return {int} day in week
     */
    MillenniumDate.prototype.getDay = function () {
        return (this.dayNumber + 6) % 7; // dayNumber = 0 was a Saturday
    };
    // Actual
    MillenniumDate.prototype.getWeek = function (arg1, arg2, arg3) {
        var weekObject;
        if (arg3 === undefined) {
            weekObject = new MillenniumWeek_1.MillenniumWeek(this, arg1, arg2);
        }
        else {
            weekObject = new MillenniumWeek_1.MillenniumWeek(this, arg2, arg3);
        }
        return weekObject.week(arg1 === true);
    };
    /**
     * Return the week number.
     * @return {int} week in year
     */
    MillenniumDate.prototype.getMillenniumWeek = function (firstDayOfWeek, daysInFirstWeek) {
        return new MillenniumWeek_1.MillenniumWeek(this, firstDayOfWeek, daysInFirstWeek);
    };
    MillenniumDate.prototype.getWeekYear = function (firstDayOfWeek, daysInFirstWeek) {
        var year = parseInt("".concat(this.getWeek(true, firstDayOfWeek, daysInFirstWeek)).substring(0, 2), 10);
        return year + 2000;
    };
    MillenniumDate.prototype.isDayBefore = function (day) {
        return this.dayNumber === day.getDayNumber() - 1;
    };
    MillenniumDate.prototype.isSameDayAs = function (other) {
        return this.dayNumber === other.getDayNumber();
    };
    // Consider the weekend to always be the two last days in the locale-sorted list of weekdays.
    MillenniumDate.prototype.isWeekend = function (firstDayOfWeek) {
        var weekday = MillenniumWeekday_1.MillenniumWeekday.WEEKDAYS[this.getDay()];
        if (firstDayOfWeek === undefined) {
            var SATURDAY_1 = 6;
            var SUNDAY_1 = 0;
            return weekday.getDay() === SATURDAY_1 || weekday.getDay() === SUNDAY_1;
        }
        var weekDays = MillenniumWeekday_1.MillenniumWeekday.getLocalizedWeekdayList(firstDayOfWeek);
        var SATURDAY = weekDays[5];
        var SUNDAY = weekDays[6];
        return weekday === SATURDAY || weekday === SUNDAY;
    };
    MillenniumDate.prototype.addWeeks = function (weeks) {
        return this.addDays(weeks * 7);
    };
    MillenniumDate.prototype.addDays = function (days) {
        return new MillenniumDate(this.dayNumber + days);
    };
    MillenniumDate.prototype.addMonths = function (months) {
        var year = this.getYear();
        var month = this.getMonth(); // Returns 0 to 11.
        month++; // Month is now 1-12
        var startMonth = month;
        month = month + months; // This is the modified month number
        if (month > 12) {
            year = year + Math.floor(month / 12);
            month = month % 12;
        }
        else if (month === 0) {
            year--;
            month = 12;
        }
        else if (month < 0) {
            if (Math.floor(Math.abs(month) / 12) === 0) {
                year--;
            }
            else {
                year = year - Math.floor(Math.abs(month) / 12); // month is negative, so floor would round up!
            }
            var monthsLeft = month % 12;
            if (-monthsLeft > startMonth) {
                year--;
                monthsLeft = 12 + monthsLeft;
            }
            else {
                monthsLeft = 12 + monthsLeft;
            }
            month = monthsLeft;
        }
        var day = this.getDate();
        return MillenniumDate.create(year, month, day);
    };
    MillenniumDate.prototype.addYears = function (years) {
        return MillenniumDate.create(this.getYear() + years, this.getMonth() + 1, this.getDate());
    };
    MillenniumDate.prototype.equals = function (obj) {
        if (this === obj) {
            return true;
        }
        if (obj === null || obj === undefined) {
            return false;
        }
        if (!(obj instanceof MillenniumDate)) {
            return false;
        }
        return this.dayNumber === obj.getDayNumber();
    };
    MillenniumDate.prototype.format = function (format) {
        format = format || "yyyyMMdd";
        return SimpleDateFormat_1.SimpleDateFormat.format(this, format);
    };
    MillenniumDate.prototype.toString = function () {
        return this.format();
    };
    MillenniumDate.MAX_DAY_NUMBER = 24836;
    MillenniumDate.UNDEFINED_DAY_NUMBER = 32767;
    MillenniumDate.INVALID_DATE = -1;
    MillenniumDate.MIN_YEAR = 2000;
    MillenniumDate.MAX_YEAR = 2067;
    return MillenniumDate;
}());
exports.MillenniumDate = MillenniumDate;
